<div class="container" id="admin">
  <div class="row">
    <div class="col-md-12">
      <h1 id="uploadLabel">Upload Bulk Purchase file</h1>
    </div>
  </div>
  <div *ngIf="error" class="row mb-3">
    <div class="col-md-12">
      <div role="alert" class="font-weight-bold text-danger" aria-live="assertive">
        <i class="fas fa-ban"></i> {{error}}
      </div>
    </div>
  </div>
  <div *ngIf="uploadInfo.finished && 0 === uploadInfo.errors?.length" class="row mb-3">
    <div class="col-md-12">
      <div role="alert" class="font-weight-bold text-success" aria-live="assertive">
        <i class="fas fa-thumbs-up"></i> File uploaded successfully.
      </div>
    </div>
  </div>
  <ng-container *ngIf="uploadInfo.finished && 0 < uploadInfo.errors?.length">
    <div class="row mb-3">
      <div class="col-md-12">
        <div role="alert" class="font-weight-bold text-warning" aria-live="assertive">
          <i class="fas fa-exclamation-triangle"></i> File uploaded with errors.
        </div>
      </div>
    </div>
    <ul *ngFor="let error of uploadInfo.errors" class="list-unstyled">
      <li>{{error}}</li>
    </ul>
    <div class="row">
      <div class="col-md-12">
        <p class="text-muted"><sup>*</sup> You may find the number of line related to specific error in the brackets.</p>
      </div>
    </div>
  </ng-container>

  <div *ngIf="uploadInfo.processing" class="row mb-3">
    <div class="col-md-12">
      <div class="progress">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
             [attr.aria-valuenow]="uploadInfo.progress" aria-valuemin="0" aria-valuemax="100" [style.width.%]="uploadInfo.progress"></div>
      </div>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-12">
        <input aria-labelledby="uploadLabel" type="file" name="uploadFile" (change)="onFileChange($event)" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12">
        <button type="submit" class="btn btn-primary">Upload</button>
      </div>
    </div>
  </form>
</div>
